"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetObject = exports.normalizeStringInObject = exports.isString = exports.isObject = void 0;

require("core-js/modules/es.string.trim.js");

var _defined = _interopRequireDefault(require("../core/defined"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isString = function isString(value) {
  if ((0, _defined.default)(value) && (typeof value === 'string' || value instanceof String)) return true;else return false;
};

exports.isString = isString;

var isObject = function isObject(value) {
  return (0, _defined.default)(value) && value.constructor === {}.constructor;
};

exports.isObject = isObject;

var normalizeStringInObject = function normalizeStringInObject(obj) {
  if (!(0, _defined.default)(obj)) return;

  for (var key in obj) {
    if (isString(obj[key])) {
      obj[key] = obj[key].trim();

      if (obj[key] === "") {
        obj[key] = undefined;
      }
    }
  }
};

exports.normalizeStringInObject = normalizeStringInObject;

var resetObject = function resetObject(obj) {
  if (!(0, _defined.default)(obj)) return obj;

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      //remove key for null/undefined value
      // if(!defined(obj[key])) {
      //     delete obj[key];
      // }
      //trim string and remove key for empty string
      //else 
      if (isString(obj[key])) {
        obj[key] = obj[key].trim();

        if (obj[key] === "") {
          obj[key] = undefined;
        }
      } else if (isObject(obj[key])) {
        resetObject(obj[key]); // if(Object.keys(obj[key]).length === 0) {
        //     delete obj[key];
        // }
      }
    }
  } //return (defined(obj) && Object.keys(obj).length === 0 ? null : obj)


  return obj;
};

exports.resetObject = resetObject;